import CartItem from '../components/CartItem';
import CartItemHOC from 'HOC/CartItem';

export default CartItemHOC(CartItem);
